<template>
  <div>
    <notifications></notifications>

    <div
      class="header pb-8 pt-6 pt-lg-6 d-flex align-items-center profile-header"
    >
      <b-container fluid>
        <span class="mask" :style="{ background: 'linear-gradient(90deg, #4d545b, #33383e)', opacity: 0.8 }"></span>
        <b-container fluid class="d-flex align-items-center">
          <b-row>
            <b-col lg="7" md="10">
              <h1 class="display-2 text-white">Nuevo Usuario</h1>
            </b-col>
          </b-row>
        </b-container>
      </b-container>
    </div>

    <b-container fluid class="mt--6">
      <b-card>
        <b-card-body>
          <form @submit.prevent="ingresarUser">
            <b-row class="form-group">
              <label class="col-md-2 col-form-label form-control-label"
                >NOMBRE DE USUARIO:</label
              >
              <b-col md="10">
                <base-input
                  v-model="datosnombreUser"
                  type="text"
                  placeholder="Ingresar nombre de usuario"
                />
              </b-col>
            </b-row>
            <b-row class="form-group">
              <label class="col-md-2 col-form-label form-control-label"
                >CONTRASEÑA:</label
              >
              <b-col md="10">
                <base-input
                  v-model="datoscontraUser"
                  type="password"
                  autocomplete="current-password"
                  placeholder="Ingrese su contraseña"
                  required: true
                />
              </b-col>
            </b-row>
            <b-row class="form-group">
              <label class="col-md-2 col-form-label form-control-label"
                >ID ORG:</label
              >
              <b-col md="10">
                <base-input>
                  <select class="form-control" v-model="selectedOrg" >
                    <option
                      v-for="org in orgOptions"
                      :key="org.ID_ORG"
                      :value="org.ID_ORG"
                    >
                      {{ org.NAME_ORG }}
                    </option>
                  </select>
                </base-input>
              </b-col>
            </b-row>
            <b-row class="form-group">
              <label class="col-md-2 col-form-label form-control-label"
                >Rol:</label
              >
              <b-col md="10">
                <base-input>
                  <select class="form-control" v-model="datosrolUser">
                    <option value=1>Administrador</option>
                    <option value=2>Usuario</option>
                  </select>
                </base-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <base-button
                  type="success"
                  @click="ingresarUser"
                  :loading="isLoading"
                >
                  {{ isLoading ? "Guardando..." : "Guardar" }}
                </base-button>
                <base-button type="warning" @click="$router.push('/User')"
                  >Cancelar</base-button
                >
              </b-col>
            </b-row>
          </form>
        </b-card-body>
      </b-card>
    </b-container>
    <token-expired-modal :show="showTokenExpiredModal"> </token-expired-modal>
  </div>
</template>

<script>
import axios from "axios";
import TokenExpiredModal from '../components/TokenExpiredModal.vue';

export default {
  components: {
    TokenExpiredModal
  },
  data() {
    return {
      datosidUser: "",
      datosnombreUser: "",
      datoscontraUser: "",
      datosrolUser: "",
      selectedOrg: null,
      orgOptions: [], // Lista de organizaciones
      isLoading: false,
      showTokenExpiredModal: false,
      currentPage: 1, // Página actual
      itemsPerPage: 10, // Elementos por página
      totalItems: 0, // Total de organizaciones
      isFetching: false, // Para evitar múltiples llamadas simultáneas
    };
  },
  methods: {
    // Traer listado de organizaciones
    async fetchOrgOptions() {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          this.mostrarError("Token no presente. Usuario no autenticado.");
          return;
        }

        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}/obtenerTodasLasOrgs`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.success) {
          this.orgOptions = response.data.data; // Cargar TODAS las organizaciones
        } else {
          this.mostrarError(
            response.data.message || "Error al cargar organizaciones"
          );
        }
      } catch (error) {
        console.error("Error en la solicitud:", error);
        this.mostrarError(
          "Error al cargar organizaciones. Verifica la conexión."
        );
      }
    },

    // Ingresar nuevo usuario
    async ingresarUser() {
      this.isLoading = true;

      try {
        const token = localStorage.getItem("token");
        if (!token) {
          this.mostrarError("Token no presente. Usuario no autenticado.");
          return;
        }

        if (
          !this.datosnombreUser ||
          !this.datoscontraUser ||
          !this.selectedOrg ||
          !this.datosrolUser
        ) {
          this.mostrarError("Por favor, complete todos los campos.");
          return;
        }

        const datos = {
          ID: this.datosidUser,
          NAME: this.datosnombreUser,
          IDORG: this.selectedOrg,
          CONTRA: this.datoscontraUser,
            ROL: this.datosrolUser,
        };

        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}/insertarDatosUSER`,
          datos,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data.success) {
          this.mostrarExito("Datos Insertados Correctamente");
          this.$router.push("/User");
        } else {
          this.mostrarError(response.data.message || "Error al Insertar Datos");
        }
      } catch (error) {
        console.error("Error al insertar datos:", error);
        this.mostrarError("Error al Insertar Datos");
      } finally {
        this.isLoading = false;
      }
    },
    mostrarError(mensaje) {
      this.$notifications.addNotification({
        type: "danger",
        message: mensaje,
      });
    },
    mostrarExito(mensaje) {
      this.$notifications.addNotification({
        type: "success",
        message: mensaje,
      });
    },
    handleTokenExpired() {
        this.showTokenExpiredModal = true;
        setTimeout(() => {
          this.$router.push("/login");
        }, 3000);
      },
  },
  mounted() {
    this.fetchOrgOptions(); // Cargar las primeras organizaciones al montar el componente
  },
};
</script>
